module.exports = __webpack_public_path__ + "static/media/retirementFunds.f4498294.svg";